<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('samples.range_add_info') }}</p>
    <hr />
    <br />
    <template>
      <div class="custom-table-responsive table-responsive">
        <table
          class="table table-striped table-bordered table table-journals not-last-td"
        >
          <thead>
            <tr class="cusmtom-thead-color">
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('samples.range_name') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_lower_operator') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_lower') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_upper_operator') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_upper') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.recommendation_kg_ha') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.color') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.text_color') }} *
              </th>
              <th scope="col" class="text-center p-0 custom-header-label">
                {{ $t('common_words.actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index_num in range_len" :key="index_num">
              <td class="text-center" style="min-width: 200px">
                <fg-input
                  style="width: 80%; margin-right: auto; margin-left: auto"
                  class="required-second-step required-names"
                  type="text"
                  v-model="model.names[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center vertical-custom" style="min-width: 200px">
                <el-select
                  style="width: 40%; margin: auto"
                  clearable
                  class="select-primary custom-width-select shadow-sm ops-rels required-second-step required-lim_inf_operators"
                  size="large"
                  v-model="model.lim_inf_operators[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                  @change="disableSup(index_num - 1)"
                  filterable
                >
                  <el-option value=">" label=">"></el-option>
                  <el-option value=">=" label=">="></el-option>
                  <el-option value="=" label="="></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 200px">
                <fg-input
                  style="width: 50%; margin-right: auto; margin-left: auto"
                  class="required-second-step required-infs"
                  type="number"
                  v-model.number="model.lim_infs[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center vertical-custom" style="min-width: 210px">
                <el-select
                  style="width: 40%; margin: auto"
                  clearable
                  class="select-primary custom-width-select shadow-sm required-opsups"
                  size="large"
                  v-model="model.lim_sup_operators[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                  :disabled="disabled_sups[index_num - 1]"
                  filterable
                >
                  <el-option value="<" label="<"></el-option>
                  <el-option value="<=" label="<="></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 200px">
                <fg-input
                  style="width: 50%; margin-right: auto; margin-left: auto"
                  type="number"
                  class="required-sups"
                  v-model.number="model.lim_sups[index_num - 1]"
                  :disabled="disabled_sups[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center" style="min-width: 160px">
                <fg-input
                  style="width: 50%; margin-right: auto; margin-left: auto"
                  class="required-second-step required-recommendations"
                  type="number"
                  v-model.number="model.recommendations[index_num - 1]"
                >
                </fg-input>
              </td>

              <td class="text-center" style="min-width: 80px">
                <button
                  class="custom-btn-color"
                  @click="openColorDialog(index_num - 1)"
                >
                  <span
                    class="custom-text-color"
                    :style="{
                      background: model.color[index_num - 1] || '#ffffff',
                    }"
                  ></span>
                  {{ $t('common_words.select') }}
                </button>
              </td>
              <td class="text-center" style="min-width: 180px">
                <button
                  class="custom-btn-color"
                  @click="openColorTextDialog(index_num - 1)"
                >
                  <span
                    class="custom-text-color"
                    :style="{
                      background: model.text_color[index_num - 1] || '#ffffff',
                    }"
                  ></span>
                  <span>{{ $t('common_words.select') }}</span>
                </button>
              </td>
              <td class="text-center vertical-custom" style="min-width: 100px">
                <div class="d-flex justify-content-center mt-3">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.edit')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click.prevent="addRow"
                  >
                    <em class="fa fa-plus custom-size-fa-actions"></em>
                  </a>
                  <a
                    v-if="range_len > 1"
                    v-tooltip.top-center="$t('common_words.erase')"
                    class="btn-danger btn-simple btn-link custom-margin-actions"
                    @click="handleDelete(index_num - 1)"
                  >
                    <em class="fa fa-times custom-size-fa-actions"></em>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-show="errorAlert">
        <div class="col-lg-12">
          <br />
          <el-alert
            ref="error_alert"
            :title="$t('common_words.errors')"
            type="error"
            >{{ error }}</el-alert
          >
        </div>
      </div>

      <el-dialog
        :visible.sync="colorDialogVisible"
        :title="$t('common_words.select_color')"
        width="400px"
      >
        <div class="col-12 form-group has-label">
          <label>{{ $t('common_words.color') }} *</label>
          <sketch-picker v-model="tempColor" style="margin-bottom: 16px" />
        </div>
        <span slot="footer" class="dialog-footer">
          <button
            class="btn btn-danger custom-shadow-btn"
            @click="colorDialogVisible = false"
          >
            {{ $t('common_words.cancel') }}</button
          >&nbsp;
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="saveColorDialog"
          >
            {{ $t('common_words.confirm') }}
          </button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="colorTextDialogVisible"
        :title="$t('common_words.select_color')"
        width="400px"
      >
        <div class="col-12 form-group has-label">
          <label>{{ $t('common_words.text_color') }} *</label>
          <sketch-picker v-model="tempTextColor" />
        </div>
        <span slot="footer" class="dialog-footer">
          <button
            class="btn btn-danger custom-shadow-btn"
            @click="colorTextDialogVisible = false"
          >
            {{ $t('common_words.cancel') }}</button
          >&nbsp;
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="saveColorTextDialog"
          >
            {{ $t('common_words.confirm') }}
          </button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import MixinColors from 'src/util/mixinColor';

export default {
  data() {
    return {
      model: {
        names: [],
        lim_inf_operators: [],
        lim_infs: [],
        lim_sup_operators: [],
        lim_sups: [],
        recommendations: [],
        color: [],
        text_color: [],
      },
      disabled_sups: [false],
      range_len: 1,
      colorDialogVisible: false,
      colorTextDialogVisible: false,
      colorDialogIndex: null,
      colorTextDialogIndex: null,
      tempColor: '',
      tempTextColor: '#00000',
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinColors],

  methods: {
    cleanStep() {
      this.model = {
        names: [],
        lim_inf_operators: [],
        lim_infs: [],
        lim_sup_operators: [],
        lim_sups: [],
        recommendations: [],
        text_color: [],
        color: [],
        details_ids_bck: [],
        details_ids: [],
      };
      this.range_len = 1;
    },

    addRow() {
      this.disabled_sups.push(false);
      this.range_len++;
    },

    openColorDialog(idx) {
      this.colorDialogIndex = idx;
      this.tempColor = this.model.color[idx] || '';
      this.colorDialogVisible = true;
    },

    openColorTextDialog(idx) {
      this.colorTextDialogIndex = idx;
      this.tempTextColor = this.model.text_color[idx] || '';
      this.colorTextDialogVisible = true;
    },

    saveColorDialog() {
      const hex =
        typeof this.tempColor === 'object'
          ? this.tempColor.hex
          : this.tempColor;
      this.$set(this.model.color, this.colorDialogIndex, hex);
      this.colorDialogVisible = false;
    },

    saveColorTextDialog() {
      const hex =
        typeof this.tempTextColor === 'object'
          ? this.tempTextColor.hex
          : this.tempTextColor;
      this.$set(this.model.text_color, this.colorTextDialogIndex, hex);
      this.colorTextDialogVisible = false;
    },

    validate() {
      let passed = true;
      this.model.names.forEach((_, index) => {
        if (this.model.lim_inf_operators[index] == null) {
          this.validationInput('lim_inf_operators', index);
          passed = false;
        } else if (this.model.lim_infs[index] == null) {
          this.validationInput('infs', index);
          passed = false;
        } else if (
          this.model.lim_sups[index] &&
          parseFloat(this.model.lim_infs[index]) >=
            parseFloat(this.model.lim_sups[index])
        ) {
          this.validationInput('infs', index);
          SweetAlert.warning(
            `${i18n.t('show_notification.ground.limits_warning')}`
          );

          passed = false;
        } else if (
          this.model.lim_sups[index] &&
          this.model.lim_sup_operators[index] == null
        ) {
          this.validationInput('opsups', index);
          SweetAlert.warning(
            `${i18n.t('show_notification.ground.lower_operator_notice')}`
          );

          passed = false;
        } else if (
          index > 0 &&
          parseFloat(this.model.lim_infs[index - 1]) >=
            parseFloat(this.model.lim_infs[index])
        ) {
          this.validationInput('infs', index);
          SweetAlert.warning(
            `${i18n.t('show_notification.ground.ranges_warning')}`
          );

          passed = false;
        } else if (
          index > 0 &&
          parseFloat(this.model.lim_sups[index - 1]) != 0 &&
          this.model.lim_sup_operators[index - 1] != null &&
          ((this.model.lim_sup_operators[index - 1] == '<' &&
            parseFloat(this.model.lim_infs[index]) <=
              parseFloat(this.model.lim_sups[index - 1])) ||
            (this.model.lim_sup_operators[index - 1] == '<=' &&
              parseFloat(this.model.lim_infs[index]) <
                parseFloat(this.model.lim_sups[index - 1])))
        ) {
          this.validationInput('infs', index);

          if (this.model.lim_sup_operators[index - 1] == '<') {
            SweetAlert.warning(
              `${i18n.t('message.ground.new_range_size_notice')}`
            );
          } else if (this.model.lim_sup_operators[index - 1] == '<=') {
            SweetAlert.warning(
              `${i18n.t('message.ground.new_range_size_warning')}`
            );
          }

          passed = false;
        } else if (!this.model.color[index]) {
          SweetAlert.warning(
            `${i18n.t('show_notification.ground.select_color')}`
          );
          passed = false;
        } else if (!this.model.text_color[index]) {
          SweetAlert.warning(
            `${i18n.t('show_notification.ground.select_text_color')}`
          );
          passed = false;
        }
      });

      if (passed) {
        return this.$validator
          .validateAll()
          .then((res) => {
            this.$emit('on-validated', res, this.model);
            this.$emit('fillrangeGroundForm', 'secondStep');
          })
          .then((resp) => {
            return this.validationInputsRequired('second-step');
          });
      }
    },

    disableSup(index) {
      if (this.model.lim_inf_operators[index] == '=') {
        this.disabled_sups[index] = true;
        this.model.lim_sup_operators[index] = null;
        this.model.lim_sups[index] = null;
      } else {
        this.disabled_sups[index] = false;
      }
    },

    handleDelete(indexnum) {
      try {
        this.model.names.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_inf_operators.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_infs.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_sup_operators.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_sups.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.recommendations.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.details_ids.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.disabled_sups.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.color.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.text_color.splice(indexnum, 1);
      } catch (error) {}

      this.range_len--;
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        let editForm = JSON.parse(sessionStorage.getItem('editForm'));

        this.model.names = Object.assign([], editForm.names);
        this.model.lim_inf_operators = Object.assign(
          [],
          editForm.lim_inf_operators
        );
        this.model.lim_infs = Object.assign([], editForm.lim_infs);
        this.model.lim_sup_operators = Object.assign(
          [],
          editForm.lim_sup_operators
        );
        this.model.lim_sups = Object.assign([], editForm.lim_sups);
        this.model.recommendations = Object.assign(
          [],
          editForm.recommendations
        );
        this.model.details_ids = Object.assign([], editForm.details_ids);
        this.model.details_ids_bck = Object.assign(
          [],
          editForm.details_ids_bck
        );

        this.model.color = Object.assign([], editForm.colors);
        this.model.text_color = Object.assign([], editForm.text_colors);
        this.model.id = editForm.id;
        this.range_len = editForm.range_details.length;

        this.showHideLoading();
      } else {
        this.showHideLoading();
      }
    } else {
      this.showHideLoading();
    }
  },
};
</script>
<style>
.custom-btn-color {
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-text-color {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  margin-bottom: 2px;
  border-radius: 4px;
}
</style>
